import React from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import BurgerBuilder from './BurgerBuilder/BurgerBuilder';
import Orders from './BurgerBuilder/Orders/Orders';
import Checkout from './BurgerBuilder/Orders/Checkout/Checkout';
import Authantication from '../Authantication/Authantication';

import { Route, Switch, Redirect } from 'react-router-dom';

import { connect } from 'react-redux';
import { authCheck } from '../redux/authActionCreators';
import Logout from '../Authantication/Logout';

const mapStateToProps = state => {
    return {
        token: state.token,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        authCheck: () => dispatch(authCheck())
    }
}


class Main extends React.Component {

    componentDidMount() {
        this.props.authCheck();
    }

    render() {
        let routes = null;

        if (this.props.token === null) {
            routes = <Switch>
                <Route path='/login' exact component={Authantication} />
                <Redirect to='/login' />
            </Switch>
        } else {
            routes = <Switch>
                <Route path='/orders' exact component={Orders} />
                <Route path='/checkout' exact component={Checkout} />
                <Route path='/logout' exact component={Logout} />
                <Route path='/home' exact component={BurgerBuilder} />
                <Redirect from='/' to='/home' />
                <Redirect to='/' />
            </Switch>
        }
        return (
            <div>
                <Header />
                <div className='container'>
                    {routes}
                </div>
                <Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);